<app-order *ngIf="!orderId"></app-order>
<app-order-detail  *ngIf="orderId" [orderId]="orderId" (saveClick)="downloadAsPDF($event)"></app-order-detail>

<app-footer-bg></app-footer-bg>

<table hidden id="pdfTable" #pdfTable style="width: 100%;padding: 20px; color: #000;">
  <tr>
    <td style="font-size: 25px;padding: 20px 15px 10px;">
      <b>Order Invoice</b>
    </td>
  </tr>
  <tr>
    <td>
      <hr style="border: 1px solid #ccc;margin: 0;">
    </td>
  </tr>
  <tr>
    <td style="padding: 15px;">
      <table style="width: 100%;">
        <tr>
          <td style="width: 50%;">
            <table style="width: 100%;">
              <tr>
                <td style="font-size: 12px;">Order Number</td>
              </tr>
              <tr>
                <td style="font-size: 12px;">{{mOrderDetail?.order_number}}</td>
              </tr>
              <tr>
                <td style="font-size: 12px;">Placed on :
                  <b>{{showDate(mOrderDetail?.order_date)}}</b>
                </td>
              </tr>
            </table>
          </td>
          <td style="text-align: right;width: 50%;">
            <table style="width: 100%;">
              <tr>
                <td style="font-size: 12px;">Total</td>
              </tr>
              <tr>
                <td style="font-size: 12px;">₹{{mOrderDetail?.order_amount}}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td>
      <hr style="border: 1px solid #ccc;margin: 0;">
    </td>
  </tr>
  <tr>
    <td style="padding: 15px;">
      <table style="width: 100%;">
        <tr>
          <td style="font-size: 15px;">Shipping Address</td>
        </tr>
        <tr>
          <td style="font-size: 12px;padding-top: 10px;">{{mOrderDetail?.customer_detail?.first_name}}
          </td>
        </tr>
        <tr>
          <address style="font-size: 12px;">{{mOrderDetail?.user_address}}></address>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td>
      <hr style="border: 1px solid #ccc;margin: 0;">
    </td>
  </tr>
  <tr>
    <td style="padding: 15px;">
      <table style="width: 100%;">
        <tr>
          <td style="font-size: 12px;color: #2c2c2c;">Shipment 1 of 1</td>
        </tr>
        <tr>
          <td style="font-size: 12px;">Amount Paid ₹{{mOrderDetail?.order_amount}}</td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td>
      <hr style="border: 1px solid #ccc;margin: 0;">
    </td>
  </tr>
  <tr>
    <td style="font-size: 12px;padding: 15px;">Package Delivered On Mon, 10 April</td>
  </tr>
  <tr>
    <td style="padding: 15px;">
      <table style="width: 100%;">
        <tr *ngFor="let product of mOrderDetail?.product_detail">
          <td>
            <table style="width: 100%;">
              <tr>
                <td style="width: 70px;padding-right: 10px;">
                  <img style="max-width: 100%;"
                    [src]="product?.imageList && product?.imageList.length > 0 && product?.imageList[0]?.path ? product.imageList[0].path : 'assets/images/default-product.png'"
                    alt="image" />
                </td>
                <td>
                  <table style="width: 100%;">
                    <tr>
                      <td style="font-size: 14px;">{{product?.name}}</td>
                    </tr>
                    <tr>
                      <td style="font-size: 14px;">Qty: {{product?.product_qty}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td style="font-size: 14px;text-align: right;">
            ₹{{mOrderDetail?.order_amount}}
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td>
      <hr style="border: 1px solid #ccc;margin: 0;">
    </td>
  </tr>
  <tr>
    <td style="padding: 15px;">
      <table style="width: 100%;">
        <tr>
          <td style="font-size: 15px;" colspan="2">Payment Details</td>
        </tr>
        <tr>
          <td style="padding-top:10px;font-size: 12px;width: 50%;">
            Payment Method
          </td>
          <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
            Credit Card
          </td>
        </tr>
        <tr>
          <td style="padding-top:10px;font-size: 12px;width: 50%;">
            Subtotal (Inclusive Tax)
          </td>
          <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
            ₹{{mOrderDetail?.order_amount}}
          </td>
        </tr>
        <tr>
          <td style="padding-top:10px;font-size: 12px;width: 50%;">
            Discount
          </td>
          <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
            ₹{{mOrderDetail?.total_discount_amount}}
          </td>
        </tr>
        <tr>
          <td style="padding-top:10px;font-size: 12px;width: 50%;">
            Shipping Charges
          </td>
          <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
            ₹{{mOrderDetail?.shipping_charge}}
          </td>
        </tr>
        <tr>
          <td style="padding-top:10px;font-size: 15px;width: 50%;font-weight: bold;">
            Total:
          </td>
          <td style="padding-top:10px;font-size: 15px;width: 50%;text-align: right;font-weight: bold;">
            ₹{{mOrderDetail?.order_amount}}
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>